import Ce, { useEffect as je } from "react";
import { FlagProvider as z } from "@unleash/proxy-client-react";
import { useFlag as qe, useFlags as ze, useFlagsStatus as Je, useUnleashClient as Be, useUnleashContext as Ge, useVariant as Xe } from "@unleash/proxy-client-react";
import { UnleashToolbarProvider as Oe } from "@unleash/toolbar/react";
var A = { exports: {} }, C = {};
/**
 * @license React
 * react-jsx-dev-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var be;
function ke() {
  if (be) return C;
  be = 1;
  var a = Symbol.for("react.fragment");
  return C.Fragment = a, C.jsxDEV = void 0, C;
}
var j = {};
/**
 * @license React
 * react-jsx-dev-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ge;
function Ue() {
  return ge || (ge = 1, process.env.NODE_ENV !== "production" && function() {
    function a(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === we ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case M:
          return "Fragment";
        case Se:
          return "Portal";
        case Q:
          return "Profiler";
        case Z:
          return "StrictMode";
        case L:
          return "Suspense";
        case $:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case re:
            return (e.displayName || "Context") + ".Provider";
          case ee:
            return (e._context.displayName || "Context") + ".Consumer";
          case I:
            var r = e.render;
            return e = e.displayName, e || (e = r.displayName || r.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case D:
            return r = e.displayName || null, r !== null ? r : a(e.type) || "Memo";
          case W:
            r = e._payload, e = e._init;
            try {
              return a(e(r));
            } catch {
            }
        }
      return null;
    }
    function f(e) {
      return "" + e;
    }
    function h(e) {
      try {
        f(e);
        var r = !1;
      } catch {
        r = !0;
      }
      if (r) {
        r = console;
        var o = r.error, n = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return o.call(
          r,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          n
        ), f(e);
      }
    }
    function y() {
    }
    function k() {
      if (N === 0) {
        ne = console.log, ae = console.info, le = console.warn, se = console.error, ue = console.group, ie = console.groupCollapsed, ce = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: y,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      N++;
    }
    function U() {
      if (N--, N === 0) {
        var e = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: b({}, e, { value: ne }),
          info: b({}, e, { value: ae }),
          warn: b({}, e, { value: le }),
          error: b({}, e, { value: se }),
          group: b({}, e, { value: ue }),
          groupCollapsed: b({}, e, { value: ie }),
          groupEnd: b({}, e, { value: ce })
        });
      }
      0 > N && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function E(e) {
      if (F === void 0)
        try {
          throw Error();
        } catch (o) {
          var r = o.stack.trim().match(/\n( *(at )?)/);
          F = r && r[1] || "", fe = -1 < o.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < o.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + F + e + fe;
    }
    function _(e, r) {
      if (!e || H) return "";
      var o = q.get(e);
      if (o !== void 0) return o;
      H = !0, o = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var n = null;
      n = m.H, m.H = null, k();
      try {
        var u = {
          DetermineComponentFrameRoot: function() {
            try {
              if (r) {
                var d = function() {
                  throw Error();
                };
                if (Object.defineProperty(d.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(d, []);
                  } catch (c) {
                    var x = c;
                  }
                  Reflect.construct(e, [], d);
                } else {
                  try {
                    d.call();
                  } catch (c) {
                    x = c;
                  }
                  e.call(d.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (c) {
                  x = c;
                }
                (d = e()) && typeof d.catch == "function" && d.catch(function() {
                });
              }
            } catch (c) {
              if (c && x && typeof c.stack == "string")
                return [c.stack, x.stack];
            }
            return [null, null];
          }
        };
        u.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var l = Object.getOwnPropertyDescriptor(
          u.DetermineComponentFrameRoot,
          "name"
        );
        l && l.configurable && Object.defineProperty(
          u.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var t = u.DetermineComponentFrameRoot(), i = t[0], T = t[1];
        if (i && T) {
          var s = i.split(`
`), g = T.split(`
`);
          for (t = l = 0; l < s.length && !s[l].includes(
            "DetermineComponentFrameRoot"
          ); )
            l++;
          for (; t < g.length && !g[t].includes(
            "DetermineComponentFrameRoot"
          ); )
            t++;
          if (l === s.length || t === g.length)
            for (l = s.length - 1, t = g.length - 1; 1 <= l && 0 <= t && s[l] !== g[t]; )
              t--;
          for (; 1 <= l && 0 <= t; l--, t--)
            if (s[l] !== g[t]) {
              if (l !== 1 || t !== 1)
                do
                  if (l--, t--, 0 > t || s[l] !== g[t]) {
                    var S = `
` + s[l].replace(
                      " at new ",
                      " at "
                    );
                    return e.displayName && S.includes("<anonymous>") && (S = S.replace("<anonymous>", e.displayName)), typeof e == "function" && q.set(e, S), S;
                  }
                while (1 <= l && 0 <= t);
              break;
            }
        }
      } finally {
        H = !1, m.H = n, U(), Error.prepareStackTrace = o;
      }
      return s = (s = e ? e.displayName || e.name : "") ? E(s) : "", typeof e == "function" && q.set(e, s), s;
    }
    function R(e) {
      if (e == null) return "";
      if (typeof e == "function") {
        var r = e.prototype;
        return _(
          e,
          !(!r || !r.isReactComponent)
        );
      }
      if (typeof e == "string") return E(e);
      switch (e) {
        case L:
          return E("Suspense");
        case $:
          return E("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case I:
            return e = _(e.render, !1), e;
          case D:
            return R(e.type);
          case W:
            r = e._payload, e = e._init;
            try {
              return R(e(r));
            } catch {
            }
        }
      return "";
    }
    function v() {
      var e = m.A;
      return e === null ? null : e.getOwner();
    }
    function p(e) {
      if (te.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function P(e, r) {
      function o() {
        Ee || (Ee = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          r
        ));
      }
      o.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: o,
        configurable: !0
      });
    }
    function w() {
      var e = a(this.type);
      return ve[e] || (ve[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function Te(e, r, o, n, u, l) {
      return o = l.ref, e = {
        $$typeof: V,
        type: e,
        key: r,
        props: l,
        _owner: u
      }, (o !== void 0 ? o : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: w
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function he(e, r, o, n, u, l) {
      if (typeof e == "string" || typeof e == "function" || e === M || e === Q || e === Z || e === L || e === $ || e === ye || typeof e == "object" && e !== null && (e.$$typeof === W || e.$$typeof === D || e.$$typeof === re || e.$$typeof === ee || e.$$typeof === I || e.$$typeof === xe || e.getModuleId !== void 0)) {
        var t = r.children;
        if (t !== void 0)
          if (n)
            if (K(t)) {
              for (n = 0; n < t.length; n++)
                G(t[n], e);
              Object.freeze && Object.freeze(t);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else G(t, e);
      } else
        t = "", (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (t += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? n = "null" : K(e) ? n = "array" : e !== void 0 && e.$$typeof === V ? (n = "<" + (a(e.type) || "Unknown") + " />", t = " Did you accidentally export a JSX literal instead of a component?") : n = typeof e, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          n,
          t
        );
      if (te.call(r, "key")) {
        t = a(e);
        var i = Object.keys(r).filter(function(s) {
          return s !== "key";
        });
        n = 0 < i.length ? "{key: someKey, " + i.join(": ..., ") + ": ...}" : "{key: someKey}", de[t + n] || (i = 0 < i.length ? "{" + i.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          n,
          t,
          i,
          t
        ), de[t + n] = !0);
      }
      if (t = null, o !== void 0 && (h(o), t = "" + o), p(r) && (h(r.key), t = "" + r.key), "key" in r) {
        o = {};
        for (var T in r)
          T !== "key" && (o[T] = r[T]);
      } else o = r;
      return t && P(
        o,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), Te(e, t, l, u, v(), o);
    }
    function G(e, r) {
      if (typeof e == "object" && e && e.$$typeof !== Ae) {
        if (K(e))
          for (var o = 0; o < e.length; o++) {
            var n = e[o];
            Y(n) && X(n, r);
          }
        else if (Y(e))
          e._store && (e._store.validated = 1);
        else if (e === null || typeof e != "object" ? o = null : (o = oe && e[oe] || e["@@iterator"], o = typeof o == "function" ? o : null), typeof o == "function" && o !== e.entries && (o = o.call(e), o !== e))
          for (; !(e = o.next()).done; )
            Y(e.value) && X(e.value, r);
      }
    }
    function Y(e) {
      return typeof e == "object" && e !== null && e.$$typeof === V;
    }
    function X(e, r) {
      if (e._store && !e._store.validated && e.key == null && (e._store.validated = 1, r = pe(r), !me[r])) {
        me[r] = !0;
        var o = "";
        e && e._owner != null && e._owner !== v() && (o = null, typeof e._owner.tag == "number" ? o = a(e._owner.type) : typeof e._owner.name == "string" && (o = e._owner.name), o = " It was passed a child from " + o + ".");
        var n = m.getCurrentStack;
        m.getCurrentStack = function() {
          var u = R(e.type);
          return n && (u += n() || ""), u;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          r,
          o
        ), m.getCurrentStack = n;
      }
    }
    function pe(e) {
      var r = "", o = v();
      return o && (o = a(o.type)) && (r = `

Check the render method of \`` + o + "`."), r || (e = a(e)) && (r = `

Check the top-level render call using <` + e + ">."), r;
    }
    var Ne = Ce, V = Symbol.for("react.transitional.element"), Se = Symbol.for("react.portal"), M = Symbol.for("react.fragment"), Z = Symbol.for("react.strict_mode"), Q = Symbol.for("react.profiler"), ee = Symbol.for("react.consumer"), re = Symbol.for("react.context"), I = Symbol.for("react.forward_ref"), L = Symbol.for("react.suspense"), $ = Symbol.for("react.suspense_list"), D = Symbol.for("react.memo"), W = Symbol.for("react.lazy"), ye = Symbol.for("react.offscreen"), oe = Symbol.iterator, we = Symbol.for("react.client.reference"), m = Ne.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, te = Object.prototype.hasOwnProperty, b = Object.assign, xe = Symbol.for("react.client.reference"), K = Array.isArray, N = 0, ne, ae, le, se, ue, ie, ce;
    y.__reactDisabledLog = !0;
    var F, fe, H = !1, q = new (typeof WeakMap == "function" ? WeakMap : Map)(), Ae = Symbol.for("react.client.reference"), Ee, ve = {}, de = {}, me = {};
    j.Fragment = M, j.jsxDEV = function(e, r, o, n, u, l) {
      return he(e, r, o, n, u, l);
    };
  }()), j;
}
var _e;
function Pe() {
  return _e || (_e = 1, process.env.NODE_ENV === "production" ? A.exports = ke() : A.exports = Ue()), A.exports;
}
var J = Pe();
const O = {
  URL: "VITE_UNLEASH_URL",
  CLIENT_KEY: "VITE_UNLEASH_CLIENT_KEY"
}, B = {
  ANONYMOUS_USER_ID: "anonymous",
  REFRESH_INTERVAL: 30,
  // seconds
  METRICS_INTERVAL: 30
  // seconds
}, Ye = { BASE_URL: "/", DEV: !0, MODE: "production", PROD: !1, SSR: !1 };
function Re(a, f) {
  return Ye[a] || f || "";
}
function Ve(a, f) {
  return !!(a && f);
}
function Me(a) {
  return a ? { ...a } : {};
}
function Ie(a) {
  return {
    userId: (a == null ? void 0 : a.userId) || B.ANONYMOUS_USER_ID,
    properties: Me(a == null ? void 0 : a.properties)
  };
}
function Le() {
  import("@unleash/toolbar/toolbar.css");
}
function Ke({
  appName: a,
  context: f,
  url: h,
  clientKey: y,
  enableToolbar: k,
  unleashConfig: U,
  children: E
}) {
  const _ = h || Re(O.URL), R = y || Re(O.CLIENT_KEY), v = k ?? !0, p = Ve(_, R);
  if (je(() => {
    p && v && Le();
  }, [p, v]), !p)
    return console.warn(
      `[UnleashProvider] Unleash is not configured. Feature flags will be unavailable. Set ${O.URL} and ${O.CLIENT_KEY} environment variables or pass them as props.`
    ), /* @__PURE__ */ J.jsxDEV(
      z,
      {
        config: { url: "https://disabled", clientKey: "disabled", appName: a },
        startClient: !1,
        children: E
      },
      void 0,
      !1,
      {
        fileName: "/home/jenkins/agent/workspace/Deploys/alc-react-monorepo/packages/unleash/src/UnleashProvider.tsx",
        lineNumber: 66,
        columnNumber: 7
      },
      this
    );
  const P = Ie(f), w = {
    url: _,
    clientKey: R,
    appName: a,
    context: P,
    refreshInterval: B.REFRESH_INTERVAL,
    metricsInterval: B.METRICS_INTERVAL,
    ...U
  };
  return console.log("[UnleashProvider] Initializing with config:", {
    appName: a,
    url: _,
    enableToolbar: v
  }), v ? /* @__PURE__ */ J.jsxDEV(
    Oe,
    {
      FlagProvider: z,
      config: w,
      children: E
    },
    void 0,
    !1,
    {
      fileName: "/home/jenkins/agent/workspace/Deploys/alc-react-monorepo/packages/unleash/src/UnleashProvider.tsx",
      lineNumber: 101,
      columnNumber: 7
    },
    this
  ) : /* @__PURE__ */ J.jsxDEV(z, { config: w, children: E }, void 0, !1, {
    fileName: "/home/jenkins/agent/workspace/Deploys/alc-react-monorepo/packages/unleash/src/UnleashProvider.tsx",
    lineNumber: 110,
    columnNumber: 10
  }, this);
}
export {
  B as DEFAULTS,
  O as ENV_KEYS,
  Ke as UnleashProvider,
  Me as buildProperties,
  Ie as buildUnleashContext,
  Ve as isUnleashConfigured,
  qe as useFlag,
  ze as useFlags,
  Je as useFlagsStatus,
  Be as useUnleashClient,
  Ge as useUnleashContext,
  Xe as useVariant
};
